import { useParams } from "react-router";
import { Typography, theme } from "kosmos-ui/lib";

import { useGetProductCategoryQuery } from "api/graphql/queries/products/hooks";
import { useLayout } from "app/context/LayoutContext/hooks";
import {
  ProductCategoryContainer,
  ProductCategoryHeader,
  ProductsContainer,
} from "./styles";
import PosterCard from "app/components/PosterCard";
import RecommendationItemCard from "app/components/RecommendationItemCard";
import { ROUTES } from "app/constants/app";
import { getProductPriceToRender } from "app/helpers/products";

export default function ProductCategory() {
  const { _id } = useParams<WithId>();

  const { data: productCategoryData, loading: loadingCompanyCategoryData } =
    useGetProductCategoryQuery({ variables: { _id } });

  const { topbarHeight, announcementBarHeight } = useLayout();

  const productCategory = productCategoryData?.getProductCategory;

  const headerHeight = topbarHeight + announcementBarHeight;

  return (
    <ProductCategoryContainer>
      {loadingCompanyCategoryData ? (
        <p>Cargando categoría...</p>
      ) : (
        <>
          <ProductCategoryHeader headerHeight={headerHeight}>
            <PosterCard
              bgImg={productCategory?.image}
              style={{ height: "50vh", maxHeight: 440 }}
            >
              <Typography as="h1" variant="title1">
                {productCategory?.name}
              </Typography>

              {productCategory?.description && (
                <Typography
                  as="h2"
                  variant="paragraph1"
                  style={{ color: theme.colorsPalette.white.default }}
                >
                  {productCategory.description}
                </Typography>
              )}
            </PosterCard>
          </ProductCategoryHeader>

          <ProductsContainer>
            {productCategory?.products.map((product) => {
              return (
                <RecommendationItemCard
                  key={product._id}
                  render="article"
                  item={{
                    type: "product",
                    _id: product._id,
                    internalLink: `${ROUTES.product}/${product._id}`,
                    img: product.images && product.images[0].url,
                    name: product.name,
                    description: getProductPriceToRender(product),
                  }}
                  style={{ card: { height: 232 }, img: { height: "100%" } }}
                />
              );
            })}
          </ProductsContainer>
        </>
      )}
    </ProductCategoryContainer>
  );
}
